import React from 'react';
import { Image } from 'react-bootstrap';
import heroImageSrc from '../imgs/002b.jpg'; // Using the image from your project

const Hero: React.FC = () => {
  // Define the style for the hero image container
  const heroStyle: React.CSSProperties = {
    width: '100%',
    height: '50vh', // 50% of the viewport height
    overflow: 'hidden', // Hide any part of the image that overflows
    position: 'relative',
  };

  return (
    <>
      <style>{`
        .tournament-overlay {
          display: none;
        }
        @media (min-width: 992px) {
          .tournament-overlay {
            display: block;
            position: absolute;
            left: 10rem;
            top: 50%;
            transform: translateY(-50%);
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            background-size: 200% 200%;
            animation: heroLiveGradient 6s ease infinite;
            backdrop-filter: blur(8px);
            -webkit-backdrop-filter: blur(8px);
            padding: 1.5rem 2.5rem;
            border-radius: 14px;
            box-shadow: 0 4px 20px rgba(102, 126, 234, 0.5);
            border: 2px solid rgba(255, 255, 255, 0.4);
            text-decoration: none;
            transition: transform 0.25s ease, box-shadow 0.25s ease;
            z-index: 10;
            min-width: 220px;
          }
          .tournament-overlay:hover {
            transform: translateY(-50%) translateY(-2px) scale(1.03);
            box-shadow: 0 8px 30px rgba(102, 126, 234, 0.7);
          }
          .tournament-overlay:hover .tournament-overlay-arrow {
            transform: translateX(4px);
          }
          .tournament-overlay-icon {
            font-size: 2.5rem;
            color: #ffd700;
            display: block;
            text-align: center;
            margin-bottom: 0.5rem;
          }
          .tournament-overlay-title {
            color: #fff;
            font-weight: bold;
            font-size: 1.15rem;
            margin-bottom: 0.5rem;
            text-align: center;
          }
          .tournament-overlay-cta {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 0.6rem;
            color: #fff;
            font-weight: bold;
            font-size: 1rem;
            margin: 0;
          }
          .tournament-overlay-pulse {
            display: inline-flex;
            align-items: center;
            gap: 0.4rem;
            background: rgba(255, 59, 48, 0.95);
            color: #fff;
            font-size: 0.7rem;
            font-weight: 700;
            letter-spacing: 0.08em;
            padding: 0.2rem 0.55rem;
            border-radius: 999px;
            text-transform: uppercase;
          }
          .tournament-overlay-pulse-dot {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: #fff;
            box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
            animation: heroLivePulseDot 1.4s ease-out infinite;
          }
          .tournament-overlay-arrow {
            font-size: 1.2rem;
            color: #ffd700;
            transition: transform 0.25s ease;
          }
        }
        @keyframes heroLiveGradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        @keyframes heroLivePulseDot {
          0% { box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7); }
          70% { box-shadow: 0 0 0 10px rgba(255, 255, 255, 0); }
          100% { box-shadow: 0 0 0 0 rgba(255, 255, 255, 0); }
        }
      `}</style>
      <div style={heroStyle}>
        <Image src={heroImageSrc} className="hero-image" />
        {/* <a
          href="https://tournacore.com/t/ashridge-summer-tournament-2026"
          target="_blank"
          rel="noopener noreferrer"
          className="tournament-overlay"
        > */}
          {/* <i className="bi bi-trophy-fill tournament-overlay-icon"></i> */}
          {/* <p className="tournament-overlay-title">Ashridge Park Tournament 2026 Results</p> */}
          {/* <p style={{ color: 'rgba(255, 255, 255, 0.95)', marginBottom: '0.75rem', fontSize: '0.95rem' }}>
              June 6th-7th at St. Crispins School
          </p>
          <p className="tournament-overlay-cta">
            <span className="tournament-overlay-pulse">
              <span className="tournament-overlay-pulse-dot"></span>
              LIVE
            </span>
            
            Live Scores (Fixtures will be posted here on the day)
            <i className="bi bi-arrow-right-circle-fill tournament-overlay-arrow"></i>
          </p> */}
        {/* </a> */}
      </div>
    </>
  );
};

export default Hero;